import { MRT_SortingState } from "mantine-react-table"
import { useProductionTableColumns } from "./use-production-table-columns"
import { ProductionDto } from "../../../../../@client/Theasoft_ApiServer_Productions"
import {
  ExtendedInfinitScrollingTable,
  ExtendedTableProps,
} from "../../../-components/infinit-scrolling-table/extended-infinit-scrolling-table"

export function ExtendedProductionTable({
  ...props
}: ExtendedTableProps<"/api/Production/GetTable", ProductionDto>) {
  const { extendedColumns, defaultColumnVisibility } =
    useProductionTableColumns()

  const defaultSorting = React.useMemo<MRT_SortingState>(
    () => [{ id: "title", desc: false }],
    []
  )
  return (
    <ExtendedInfinitScrollingTable
      url="/api/Production/GetTable"
      columnDefinitions={extendedColumns}
      defaultColumVisibility={defaultColumnVisibility}
      defaultSorting={defaultSorting}
      {...props}
    />
  )
}
